import CreateSalesReportModal from './CreateSalesReportModal';

export default CreateSalesReportModal;